import { ScheduleTypeE } from 'app/common/constants/hyper-cdp.const';
import { ProductConfig } from 'app/config/switch';
import { isNumber } from 'lodash';

/**
 * 极简模式定时快照执行周期可配置时间相关表单项
 */
export const HYPER_CDP_CONFIG_POLICY_S_TIME_FORM_ITEM_LIST =
    ['second', 'minute', 'hour', 'dailyHour', 'dailyMinute', 'weeklyDay', 'weeklyTime', 'mouthlyDay', 'mouthlyTime'];
/**
 * 极简模式定时快照执行周期时间配置默认值
 */
export const CDP_S_POLICY_TIME_INITIAL = '00:00';
/**
 * 极简模式定时快照执行周期固定周期时间转化为分钟比例
 */
export const CDP_S_POLICY_FIXEDTIME_MIN_RATE = 60;
/*
 * 极简模式定时快照执行周期固定周期时间转化为小时比例
 */
export const CDP_S_POLICY_FIXEDTIME_HOUR_RATE = 3600;
/**
 * 定时HyperCDP计划策略枚举
 */
export enum FrequenciesE {
    /** 固定周期 */
    FIXED = 'FIXED',
    /** 每天 */
    DAILY = 'DAILY',
    /** 每周 */
    WEEKLY = 'WEEKLY',
    /** 每月 */
    MONTHLY = 'MONTHLY',
    /** 每秒 */
    SECONDLY = 'SECONDLY',
    /** 每分 */
    MINUTELY = 'MINUTELY',
    /** 每小时 */
    HOURLY = 'HOURLY'
}

/**
 * 定时快照执行周期每月最大天数
 */
export const MAX_HYPER_CDP_CONFIG_POLICY_SMOUTHLY_DAY = 31;
/**
 * 定时快照执行周期留存个数范围、特殊值
 */
export enum HyperCdpConfigPolicySRetainValue {
    MIN = 1,
    MAX = 6000,
    INITIAL = 1,
    CANCEL_SECURE_SNAPEN = -1,
}
/**
 * 定时快照执行周期每秒取值
 */
export enum HyperCdpConfigPolicySSecondValue {
    FILE_MIN = 15,
    BLOCK_MIN = 3,
    MAX = 59,
    FILE_INITIAL = 30,
    BLOCK_INITIAL = 10
}
/**
 * 定时快照执行周期每分取值
 */
export enum HyperCdpConfigPolicySMinuteValue {
    INITIAL = 1,
    MIN = 1,
    MAX = 1440,
}
/**
 * 定时快照执行周期每小时取值
 */
export enum HyperCdpConfigPolicySHourValue {
    MIN = 1,
    MAX = 24,
    INITIAL = 1,
}
/**
 * 定时快照执行周期每天分钟取值
 */
export enum HyperCdpConfigPolicySDailyMinuteValue {
    MIN = 0,
    MAX = 59,
    INITIAL = 0,
}
/**
 * 定时快照执行周期数量范围（最小1，最大4）
 */
export enum HyperCdpConfigPolicySNumberRange {
    MIN = 1,
    MAX = 4,
}

/**
 * 定时HyperCDP计划最大保留个数
 */
export const MAX_VALUE = {
    /** LUN保留个数最大值 */
    [ScheduleTypeE.Block]: {
        /** 固定周期 */
        [FrequenciesE.FIXED]: isNumber(ProductConfig.MaxLunHyperCdpFreqNum) ? ProductConfig.MaxLunHyperCdpFreqNum : 60000,
        /** 每天 */
        [FrequenciesE.DAILY]: isNumber(ProductConfig.MaxLunHyperCdpDailyNum) ? ProductConfig.MaxLunHyperCdpDailyNum : 512,
        /** 每周 */
        [FrequenciesE.WEEKLY]: isNumber(ProductConfig.MaxLunHyperCdpWeekqNum) ? ProductConfig.MaxLunHyperCdpWeekqNum : 256,
        /** 每月 */
        [FrequenciesE.MONTHLY]: isNumber(ProductConfig.MaxLunHyperCdpMonthNum) ? ProductConfig.MaxLunHyperCdpMonthNum : 256,
    },
    /** FS保留个数最大值 */
    [ScheduleTypeE.File]: {
        /** 固定周期 */
        [FrequenciesE.FIXED]: isNumber(ProductConfig.MaxFsHyperCdpFreqNum) ? ProductConfig.MaxFsHyperCdpFreqNum : 4096,
        /** 每天 */
        [FrequenciesE.DAILY]: isNumber(ProductConfig.MaxFsHyperCdpDailyNum) ? ProductConfig.MaxFsHyperCdpDailyNum : 512,
        /** 每周 */
        [FrequenciesE.WEEKLY]: isNumber(ProductConfig.MaxFsHyperCdpWeekqNum) ? ProductConfig.MaxFsHyperCdpWeekqNum : 256,
        /** 每月 */
        [FrequenciesE.MONTHLY]: isNumber(ProductConfig.MaxFsHyperCdpMonthNum) ? ProductConfig.MaxFsHyperCdpMonthNum : 256,
    },
};

